import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'applications',
});

export async function decryptPayload(uuid, payload) {
    return backendEndpoint.get('decrypt-payload', { params: { uuid, payload } });
}

export async function fetchGdprTexts(atsUserUuid, encryptedPayload) {
    return backendEndpoint.get(`gdpr-texts?uuid=${atsUserUuid}&payload=${encryptedPayload}`);
}
